import React from "react";
import classNames from "../../utils/classNames";

const Badge = ({ children, variant = "default" }) => {
  const variantStyles = {
    success: "bg-success text-white",
    danger: "bg-danger text-white",
    brand: "bg-brand-primary text-white",
    default: "bg-gray-500 text-white",
  };

  return (
    <span
      className={classNames(
        "inline-flex items-center px-1.5 py-1.5 leading-none rounded text-xxsm font",
        variantStyles[variant] || variantStyles.default
      )}
    >
      {children}
    </span>
  );
};

export { Badge };
